export {default as CashierPaymentsWidget} from './components/CashierPaymentsWidget/CashierPaymentsWidget';



// WEBPACK FOOTER //
// ./index.ts